/**
 * React staff dashboard URL prefix (system_administrator / operations_manager / financial_officer / support_agent).
 * Django emergency UI is served at `/core-engine/` on the API origin — not these paths.
 */
export const BACKOFFICE_BASE = '/backoffice';

export const backofficePath = (suffix: string) =>
  `${BACKOFFICE_BASE}${suffix.startsWith('/') ? suffix : `/${suffix}`}`;

export const BACKOFFICE_LOGIN_PATH = backofficePath('login');
